import React from 'react';

const icon = (
  <span className="event-cards__heading--icon-external">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.92952 16C1.3951 16 0.939914 15.812 0.563948 15.4361C0.187983 15.0601 0 14.6049 0 14.0705V1.92952C0 1.3951 0.187983 0.939913 0.563948 0.563947C0.939914 0.187982 1.3951 0 1.92952 0H8V1.92952H1.92952V14.0705H14.0705V8H16V14.0705C16 14.6049 15.812 15.0601 15.4361 15.4361C15.0601 15.812 14.6049 16 14.0705 16H1.92952ZM6.01036 11.3476L4.65244 9.98964L12.7126 1.92952H10.2317V0H16V5.76829H14.0705V3.28745L6.01036 11.3476Z"
        fill="#C74298"
      />
    </svg>
  </span>
);

const EventCardHeading = ({ heading, url, isExternalLink }) => {
  return heading && url ? (
    <h2 className={`event-cards__heading`}>
      <a href={url} className={`js-card-link event-cards__heading-link`} rel={isExternalLink ? 'noopener noreferrer' : ''} target={isExternalLink ? '_blank' : '_self'}>
        <span dangerouslySetInnerHTML={{ __html: heading }}></span> {isExternalLink && icon}
      </a>
    </h2>
  ) : null;
};

export default EventCardHeading;
